import getCssBreakpointConfig from './getCssBreakpointConfig';
import getCssBreakpoint from './getCssBreakpoint';

/**
 * Returns whether the current viewport matches the given breakpoint
 * @param {String} breakpoint
 * @return {Boolean}
 */
const matchBreakpoint = (breakpoint) => {
  const config = getCssBreakpointConfig();
  const currentBreakpoint = getCssBreakpoint();
  const currentBreakpointIndex = config.findIndex(({ name }) => name === currentBreakpoint);
  const breakpointIndex = config.findIndex(({ name }) => name === breakpoint);

  return currentBreakpointIndex >= breakpointIndex;
};

export default matchBreakpoint;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/matchBreakpoint.js